/**
 * Map internal result type names to user-friendly display names
 */
export const RESULT_TYPE_DISPLAY_NAMES = {
  open_port: 'Open Ports',
  nmap_port: 'Open Ports',
  web_technology: 'Web Technology',
  subdomain: 'Subdomain',
  dns: 'DNS',
  shodan_data: 'Shodan Data',
  vulnerability: 'Vulnerability',
  ssl_cert: 'SSL Certificate',
  http_response: 'HTTP Response',
  whois: 'WHOIS',
  asn: 'ASN',
  ip: 'IP Address',
  port: 'Port',
  service: 'Service',
  technology: 'Technology',
};

/**
 * Get display name for a result type
 * @param {string} resultType - Internal result type name
 * @returns {string} User-friendly display name
 */
export const getResultTypeDisplayName = (resultType) => {
  if (!resultType) return 'Unknown';
  
  // Check if we have a mapping
  if (RESULT_TYPE_DISPLAY_NAMES[resultType]) {
    return RESULT_TYPE_DISPLAY_NAMES[resultType];
  }
  
  // Fallback: Convert snake_case to Title Case
  return resultType
    .split('_')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};
